import { Component } from '@angular/core';
import { trigger, state, style } from '@angular/animations';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'dk-typing',
  standalone: true,
  imports: [SharedModule],
  animations: [
    trigger('typing', [
      state('active', style({
        opacity: 1,
        transform: 'scale(1)',
      })),
      state('inactive', style({
        opacity: 0.25,
        transform: 'scale(0.7)',
      })),
    ]),
  ],
  templateUrl: './dk-typing.component.html',
  styleUrl: './dk-typing.component.less'
})
export class DkTypingComponent {
  activeIndex = 0;

  constructor() {
    setInterval(() => {
      this.activeIndex = (this.activeIndex + 1) % 3;
    }, 1000);
  }
}